import { render, staticRenderFns } from "./fulfillment-header.vue?vue&type=template&id=78996353"
import script from "./fulfillment-header.vue?vue&type=script&lang=js"
export * from "./fulfillment-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports